// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rsRolePage {
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 20px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}

.rsRoleCard {
  width: 100%;
  max-width: 460px;
  padding: 28px 26px 24px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-xl, 18px);
  background: var(--surface-card, #fff);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.1);
}

.rsRoleHeader {
  padding: 4px 0 22px;
  text-align: center;
}

.rsRoleLogo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: 0 auto 16px;
}

.rsRoleLogo img {
  display: block;
  max-width: 60px;
  max-height: 60px;
}

.rsRoleHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 23px;
  font-weight: 800;
  line-height: 1.18;
  letter-spacing: 0;
}

.rsRoleHeader p {
  margin: 6px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 14.5px;
  line-height: 1.45;
}

.rsRoleControls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.rsRoleSearch {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
}

.rsRoleSearch input {
  width: 100%;
  height: var(--control-h-md, 40px);
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font: inherit;
  font-size: 14px;
  padding: 0 12px;
  outline: none;
  box-shadow: none;
}

.rsRoleSearch input:focus {
  border-color: var(--border-brand, #227ebd);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.24));
}

.rsSegment {
  display: inline-flex;
  flex: 0 0 auto;
  gap: 3px;
  padding: 3px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 9px;
  background: var(--slate-50, #f8fafc);
}

.rsSegment button {
  height: 30px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  font: inherit;
  font-size: 12.5px;
  font-weight: 650;
  padding: 0 11px;
  white-space: nowrap;
}

.rsSegment button.isActive {
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}

.rsRoleListScroll {
  max-height: 360px;
  overflow-y: auto;
  margin: 0 -6px;
  padding: 2px 6px;
}

.rsRoleListScroll::-webkit-scrollbar {
  width: 8px;
}

.rsRoleListScroll::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.16);
}

.rsRecentBlock {
  margin-bottom: 6px;
}

.rsRoleGroup {
  margin-bottom: 4px;
}

.rsRoleRows {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rsSectionLabel {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 4px 6px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-transform: uppercase;
}

.rsRecentBlock .rsSectionLabel {
  padding-top: 2px;
  padding-bottom: 8px;
}

.rsRoleRow {
  display: flex;
  align-items: center;
  gap: 13px;
  width: 100%;
  min-height: 62px;
  border: 1px solid transparent;
  border-radius: var(--radius-md, 10px);
  background: transparent;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 11px 14px;
  text-align: left;
  transition: background 0.12s ease, border-color 0.12s ease;
}

.rsRoleRow:hover {
  background: var(--slate-25, #fafbfc);
}

.rsRoleRow.isRecent {
  border-color: var(--blue-100, #d4e8f6);
  background: var(--blue-50, #eef6fc);
}

.rsRoleRow.isChoosing {
  background: var(--blue-50, #eef6fc);
}

.rsRoleCrest {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  border-radius: 11px;
  color: #fff;
  font-size: 14.5px;
  font-weight: 800;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

.rsRoleCrestUnion {
  background: #fbf1dc;
  color: #b0821f;
}

.rsRoleCrest svg {
  font-size: 20px;
}

.rsRoleRowText {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
}

.rsRoleRowPrimary {
  display: block;
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 14.5px;
  font-weight: 700;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rsRoleRowSub {
  display: block;
  margin-top: 2px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.3;
}

.rsRoleBadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  flex: 0 0 auto;
  border-radius: var(--radius-pill, 999px);
  font-size: 12px;
  font-weight: 700;
  padding: 0 10px;
  white-space: nowrap;
}

.rsRoleBadge span {
  width: 6px;
  height: 6px;
  flex: 0 0 auto;
  border-radius: 50%;
}

.rsRoleRowIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: var(--text-subtle, #94a3b8);
  opacity: 0.55;
  transition: transform 0.12s ease, opacity 0.12s ease;
}

.rsRoleRow:hover .rsRoleRowIcon {
  opacity: 1;
  transform: translateX(2px);
}

.rsRoleRow.isChoosing .rsRoleRowIcon {
  color: var(--action-primary, #227ebd);
  opacity: 1;
  transform: none;
}

.rsEmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  color: var(--text-muted, #64748b);
  text-align: center;
}

.rsEmptyState > svg {
  margin-bottom: 10px;
  color: var(--text-subtle, #94a3b8);
  font-size: 26px;
}

.rsEmptyState strong {
  color: var(--text-body, #334155);
  font-size: 14px;
  font-weight: 700;
}

.rsEmptyState span {
  margin-top: 3px;
  font-size: 13px;
}

.rsRoleFooter {
  display: flex;
  align-items: center;
  gap: 11px;
  margin-top: 16px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  padding-top: 16px;
}

.rsUserAvatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--blue-50, #eef6fc);
  color: var(--action-primary, #227ebd);
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.rsUserMeta {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
}

.rsUserMeta strong {
  display: block;
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 650;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rsUserMeta small {
  display: block;
  overflow: hidden;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rsLogoutBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 34px;
  flex: 0 0 auto;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 0 12px;
}

.rsLogoutBtn:hover {
  border-color: var(--border-strong, #94a3b8);
  background: var(--surface-hover, #f8fafc);
}

@media (max-width: 560px) {
  .rsRolePage {
    padding: 22px 12px;
  }

  .rsRoleCard {
    padding: 24px 18px 20px;
  }

  .rsRoleControls {
    align-items: stretch;
    flex-direction: column;
  }

  .rsSegment {
    width: 100%;
  }

  .rsSegment button {
    flex: 1 1 0;
  }

  .rsRoleBadge {
    display: none;
  }

  .rsLogoutBtn {
    padding: 0 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/LoginRouter/RoleSelector/RoleSelector.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,aAAa;EACb,eAAe;EACf,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".rsRolePage {\n  min-height: 100vh;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 40px 20px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n\n.rsRoleCard {\n  width: 100%;\n  max-width: 460px;\n  padding: 28px 26px 24px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-xl, 18px);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.1);\n}\n\n.rsRoleHeader {\n  padding: 4px 0 22px;\n  text-align: center;\n}\n\n.rsRoleLogo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 16px;\n}\n\n.rsRoleLogo img {\n  display: block;\n  max-width: 60px;\n  max-height: 60px;\n}\n\n.rsRoleHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 23px;\n  font-weight: 800;\n  line-height: 1.18;\n  letter-spacing: 0;\n}\n\n.rsRoleHeader p {\n  margin: 6px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 14.5px;\n  line-height: 1.45;\n}\n\n.rsRoleControls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 6px;\n}\n\n.rsRoleSearch {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1 1 auto;\n  min-width: 0;\n  margin: 0;\n}\n\n.rsRoleSearch input {\n  width: 100%;\n  height: var(--control-h-md, 40px);\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n  font-size: 14px;\n  padding: 0 12px;\n  outline: none;\n  box-shadow: none;\n}\n\n.rsRoleSearch input:focus {\n  border-color: var(--border-brand, #227ebd);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.24));\n}\n\n.rsSegment {\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 3px;\n  padding: 3px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 9px;\n  background: var(--slate-50, #f8fafc);\n}\n\n.rsSegment button {\n  height: 30px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  font: inherit;\n  font-size: 12.5px;\n  font-weight: 650;\n  padding: 0 11px;\n  white-space: nowrap;\n}\n\n.rsSegment button.isActive {\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);\n}\n\n.rsRoleListScroll {\n  max-height: 360px;\n  overflow-y: auto;\n  margin: 0 -6px;\n  padding: 2px 6px;\n}\n\n.rsRoleListScroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.rsRoleListScroll::-webkit-scrollbar-thumb {\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.16);\n}\n\n.rsRecentBlock {\n  margin-bottom: 6px;\n}\n\n.rsRoleGroup {\n  margin-bottom: 4px;\n}\n\n.rsRoleRows {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.rsSectionLabel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 4px 6px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  line-height: 1.2;\n  text-transform: uppercase;\n}\n\n.rsRecentBlock .rsSectionLabel {\n  padding-top: 2px;\n  padding-bottom: 8px;\n}\n\n.rsRoleRow {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  width: 100%;\n  min-height: 62px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md, 10px);\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font: inherit;\n  padding: 11px 14px;\n  text-align: left;\n  transition: background 0.12s ease, border-color 0.12s ease;\n}\n\n.rsRoleRow:hover {\n  background: var(--slate-25, #fafbfc);\n}\n\n.rsRoleRow.isRecent {\n  border-color: var(--blue-100, #d4e8f6);\n  background: var(--blue-50, #eef6fc);\n}\n\n.rsRoleRow.isChoosing {\n  background: var(--blue-50, #eef6fc);\n}\n\n.rsRoleCrest {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 auto;\n  border-radius: 11px;\n  color: #fff;\n  font-size: 14.5px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  text-transform: uppercase;\n}\n\n.rsRoleCrestUnion {\n  background: #fbf1dc;\n  color: #b0821f;\n}\n\n.rsRoleCrest svg {\n  font-size: 20px;\n}\n\n.rsRoleRowText {\n  display: block;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.rsRoleRowPrimary {\n  display: block;\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 14.5px;\n  font-weight: 700;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rsRoleRowSub {\n  display: block;\n  margin-top: 2px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.3;\n}\n\n.rsRoleBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 24px;\n  flex: 0 0 auto;\n  border-radius: var(--radius-pill, 999px);\n  font-size: 12px;\n  font-weight: 700;\n  padding: 0 10px;\n  white-space: nowrap;\n}\n\n.rsRoleBadge span {\n  width: 6px;\n  height: 6px;\n  flex: 0 0 auto;\n  border-radius: 50%;\n}\n\n.rsRoleRowIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  color: var(--text-subtle, #94a3b8);\n  opacity: 0.55;\n  transition: transform 0.12s ease, opacity 0.12s ease;\n}\n\n.rsRoleRow:hover .rsRoleRowIcon {\n  opacity: 1;\n  transform: translateX(2px);\n}\n\n.rsRoleRow.isChoosing .rsRoleRowIcon {\n  color: var(--action-primary, #227ebd);\n  opacity: 1;\n  transform: none;\n}\n\n.rsEmptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 20px;\n  color: var(--text-muted, #64748b);\n  text-align: center;\n}\n\n.rsEmptyState > svg {\n  margin-bottom: 10px;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 26px;\n}\n\n.rsEmptyState strong {\n  color: var(--text-body, #334155);\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.rsEmptyState span {\n  margin-top: 3px;\n  font-size: 13px;\n}\n\n.rsRoleFooter {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  margin-top: 16px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  padding-top: 16px;\n}\n\n.rsUserAvatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  background: var(--blue-50, #eef6fc);\n  color: var(--action-primary, #227ebd);\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.rsUserMeta {\n  display: block;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.rsUserMeta strong {\n  display: block;\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rsUserMeta small {\n  display: block;\n  overflow: hidden;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.25;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rsLogoutBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  height: 34px;\n  flex: 0 0 auto;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  cursor: pointer;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 0 12px;\n}\n\n.rsLogoutBtn:hover {\n  border-color: var(--border-strong, #94a3b8);\n  background: var(--surface-hover, #f8fafc);\n}\n\n@media (max-width: 560px) {\n  .rsRolePage {\n    padding: 22px 12px;\n  }\n\n  .rsRoleCard {\n    padding: 24px 18px 20px;\n  }\n\n  .rsRoleControls {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .rsSegment {\n    width: 100%;\n  }\n\n  .rsSegment button {\n    flex: 1 1 0;\n  }\n\n  .rsRoleBadge {\n    display: none;\n  }\n\n  .rsLogoutBtn {\n    padding: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
